import * as yup from 'yup';
import { adiantamentoQuinzenal } from './utils/rulesByKey';

export const AdiantamentoQuinzenalSchema = yup.object({
  ...adiantamentoQuinzenal,
});

export const AdiantamentoQuinzenalInitialValues = {
  adiantamentoQuinzenal: '',
};
